import { useState } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import HomeScreen from './components/home/HomeScreen';
import SelectedDayBottomSheet from './components/home/SelectedDayBottomSheet';
import TemplatesScreen from './components/templates/TemplatesScreen';
import BottomNavigation from './components/layout/BottomNavigation';
import FabArea from './components/layout/FabArea';
import EventFormSheet from './components/eventSheet/EventFormSheet';
import EventDetailSheet from './components/eventSheet/EventDetailSheet';
import TemplateEditorSheet from './components/templates/TemplateEditorSheet';
import TemplateActionSheet from './components/templates/TemplateActionSheet';
import Toast from './components/common/Toast';
import OfflineBanner from './components/common/OfflineBanner';

/**
 * App shell: two screens (home / templates) switched by
 * the bottom navigation, a context-aware FAB, the bottom sheets
 * (day agenda / event add-or-edit form / event detail / template
 * editor), and a single toast — mirrors the structure of the original
 * single-file mockup 1:1, just split into components.
 *
 * ※設定画面（SettingsScreen）はナビゲーションから外してある
 * （home画面のレイアウト調整の一環。コンポーネント自体は削除しておらず、
 * 復元する場合は import と <SettingsScreen /> の描画、BottomNavigation
 * のタブ定義を戻すだけでよい）。
 *
 * The event add/edit sheet and the event detail sheet read their own
 * open/closed state from AppContext (eventForm / eventDetail) rather
 * than local state here, since they're triggered from deeply nested
 * places (FAB, and event cards inside SelectedDayBottomSheet).
 */
function AppShell() {
  const { openAddEventForm, openAddTemplateForm } = useApp();
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div className="app">
      <OfflineBanner />

      <div className="screens">
        <HomeScreen active={activeTab === 'home'} />
        <TemplatesScreen active={activeTab === 'templates'} />
      </div>

      <SelectedDayBottomSheet />

      <FabArea
        activeTab={activeTab}
        onAddEvent={openAddEventForm}
        onAddTemplate={openAddTemplateForm}
      />

      <BottomNavigation activeTab={activeTab} onChange={setActiveTab} />

      <EventFormSheet />
      <EventDetailSheet />
      <TemplateEditorSheet />
      <TemplateActionSheet />

      <Toast />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppShell />
    </AppProvider>
  );
}
